export const userKeys = {
  all: ['users'] as const,
  current: () => [...userKeys.all, 'current'] as const,
  detail: (id: string) => [...userKeys.all, id] as const,
} as const;

export const chartKeys = {
  all: ['charts'] as const,
  lists: () => [...chartKeys.all, 'list'] as const,
  list: (filters: Record<string, unknown>) => [...chartKeys.lists(), filters] as const,
  details: () => [...chartKeys.all, 'detail'] as const,
  detail: (id: string) => [...chartKeys.details(), id] as const,
} as const;

export const profileKeys = {
  all: ['profiles'] as const,
  lists: () => [...profileKeys.all, 'list'] as const,
  list: (userId: string) => [...profileKeys.lists(), userId] as const,
  details: () => [...profileKeys.all, 'detail'] as const,
  detail: (id: string) => [...profileKeys.details(), id] as const,
} as const;

export const templateKeys = {
  all: ['templates'] as const,
  lists: () => [...templateKeys.all, 'list'] as const,
  system: () => [...templateKeys.lists(), 'system'] as const,
  user: (userId: string) => [...templateKeys.lists(), userId] as const,
  details: () => [...templateKeys.all, 'detail'] as const,
  detail: (id: string) => [...templateKeys.details(), id] as const,
} as const;

export const patientKeys = {
  all: ['patients'] as const,
  lists: () => [...patientKeys.all, 'list'] as const,
  list: (officeId: string) => [...patientKeys.lists(), officeId] as const,
  details: () => [...patientKeys.all, 'detail'] as const,
  detail: (id: string) => [...patientKeys.details(), id] as const,
} as const;

export const legalKeys = {
  all: ['legal'] as const,
  config: () => [...legalKeys.all, 'config'] as const,
} as const;
